import React from 'react';
import PropTypes from 'prop-types';
import { getRecommend } from '../../../../../../services/api';
import errorBoundary from '@ifeng/errorBoundary';
import Recommend from './recommend';

class Request extends React.PureComponent {
    static propTypes = {
        ad: PropTypes.object,
    };

    state = {
        data: [],
    };

    async componentDidMount() {
        try {
            const data = await getRecommend();

            if (data) {
                this.setState({
                    data,
                });
            }
        } catch (e) {
            console.error(e);
        }
    }

    render() {
        const { data } = this.state;
        const { ad } = this.props;

        if (data && data.length > 0) {
            return <Recommend data={data} ad={ad} />;
        }

        return null;
    }
}

export default errorBoundary(Request);
